import {
  UNIT_TRUST_INVESTMENT_ACCOUNT,
  EQUITY_INVESTMENT_ACCOUNT,
  STRUCTURED_PRODUCTS_ACCOUNT,
  BONDS_ACCOUNT,
  HSBC_CONVENTIONAL_UT_ACCOUNT,
  HSBC_AMANAH_UT_ACCOUNT,
} from 'srcAlias/client/enums/productDescriptionCode';
import {
  UNIT_TRUST_INVESTMENT_ACCOUNT_CATEGORY,
  EQUITY_INVESTMENT_ACCOUNT_CATEGORY,
  STRUCTURED_PRODUCTS_ACCOUNT_CATEGORY,
  BONDS_ACCOUNT_CATEGORY,
} from 'srcAlias/client/enums/productCategory';
export const getProductTypeLabels = {
  [`${EQUITY_INVESTMENT_ACCOUNT}_${EQUITY_INVESTMENT_ACCOUNT_CATEGORY}`]: {
    heading: 'headingForEquities',
    labelText: 'equityLabelText',
    informationText: 'informationTextEquity',
    headingHelpText: 'investMarkets',
    helpText: 'investMarketsHelpTxtEquity',
    helpText2: '',
  },
  [`${UNIT_TRUST_INVESTMENT_ACCOUNT}_${UNIT_TRUST_INVESTMENT_ACCOUNT_CATEGORY}`]:
    {
      heading: 'headingForNonStructuredProducts',
      labelText: 'unitTrustLabelText',
      informationText: '',
      headingHelpText: 'beforeTradingUT',
      helpText: 'unitTrustHelpText',
      helpText2: 'investMarketsHelpText',
    },
  [`${STRUCTURED_PRODUCTS_ACCOUNT}_${STRUCTURED_PRODUCTS_ACCOUNT_CATEGORY}`]: {
    heading: 'headingForStructuredProducts',
    labelText: 'structuredProductsLabelText',
    informationText: 'informationTextEquity',
    headingHelpText: 'beforeTradingUT',
    helpText: 'structuredProductsHelpText',
    helpText2: '',
  },
  [`${BONDS_ACCOUNT}_${BONDS_ACCOUNT_CATEGORY}`]: {
    heading: 'headingForNonStructuredProducts',
    labelText: 'bondsLabelText',
    informationText: '',
    headingHelpText: 'beforeTradingUT',
    helpText: 'bondsHelpText',
    helpText2: '',
  },
  [`${HSBC_CONVENTIONAL_UT_ACCOUNT}_${UNIT_TRUST_INVESTMENT_ACCOUNT_CATEGORY}`]:
    {
      heading: 'headingForNonStructuredProducts',
      labelText: 'unitTrustParagraphText',
      informationText: '',
      headingHelpText: '',
      helpText: '',
      helpText2: '',
    },
  [`${HSBC_AMANAH_UT_ACCOUNT}_${UNIT_TRUST_INVESTMENT_ACCOUNT_CATEGORY}`]: {
    heading: 'headingForNonStructuredProducts',
    labelText: 'unitTrustParagraphText',
    informationText: '',
    headingHelpText: '',
    helpText: '',
    helpText2: '',
  },
};
